import { render, staticRenderFns } from "./laundrymanage.vue?vue&type=template&id=1b053077&scoped=true&"
import script from "./laundrymanage.vue?vue&type=script&lang=js&"
export * from "./laundrymanage.vue?vue&type=script&lang=js&"
import style0 from "./laundrymanage.vue?vue&type=style&index=0&id=1b053077&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b053077",
  null
  
)

export default component.exports